import { default as Snackbar, SnackbarProps } from "@mui/material/Snackbar";

export { Snackbar };
export type { SnackbarProps };
